import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import { state } from "./state";

export const user = {
  state,
  mutations,
  actions,
  getters
};
